import { Directive } from '@angular/core';

@Directive({
  selector: '[uiSliderSlide]',
})
export class SliderSlideDirective {
}
